import axios from "./axiosService";
import services from "./base";

const templateService = {
  getAllTemplates: async () => {
    try {
      const response = await axios.get(services.urlTemplate);
      return response.data;
    } catch (error) {
      return error.message;
    }
  },

  createTemplate: async (obj) => {
    try {
      const response = await axios.post(services.urlTemplate, { obj });
      if (response.data.error) {
        return response.data.error;
      } else {
        return response.status;
      }
    } catch (error) {
      console.log(error);
      return error.message;
    }
  },

  updateTemplateById: async (obj) => {
    try {
      const response = await axios.patch(`${services.urlTemplate}/${obj.id}`, obj);
      return response.data;
    } catch (error) {
      console.error("Error updating template:", error);
      throw new Error(error.response?.data?.message || "Error updating template");
    }
  },

  deleteTemplateById: async (id) => {
    try {
      const response = await axios.delete(services.urlTemplate + "/" + id, { params: { id } });
      return response.data;
    } catch (error) {
      return error.message;
    }
  },
};

export default templateService;
